import React from 'react';
import { ServiceStatus } from '../../../types/service.type';
import { getStatusConfig } from '../../../config/serviceStatusConfig';

interface ServiceStatusBadgeProps {
  status: ServiceStatus;
  size?: 'sm' | 'md' | 'lg';
  showLabel?: boolean;
  showIcon?: boolean;
  animated?: boolean;
  className?: string;
}

const ServiceStatusBadge: React.FC<ServiceStatusBadgeProps> = ({
  status,
  size = 'md',
  showLabel = true,
  showIcon = true,
  animated = true,
  className = '',
}) => {
  const config = getStatusConfig(status);

  if (!config) {
    console.warn(`Status config not found for status: ${status}`);
    return null;
  }

  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-1 text-sm',
    lg: 'px-3 py-1.5 text-base',
  };

  const dotSizes = {
    sm: 'w-1.5 h-1.5',
    md: 'w-2 h-2',
    lg: 'w-2.5 h-2.5',
  };

  return (
    <span
      className={`
        inline-flex items-center gap-1.5 rounded-full font-medium border
        ${config.bgColor} ${config.borderColor} ${config.textColor}
        ${sizeClasses[size]}
        ${className}
      `}
    >
      {showIcon && (
        <span
          className={`
            flex-shrink-0 rounded-full ${config.color} ${dotSizes[size]}
            ${animated && config.animated ? 'animate-pulse' : ''}
          `}
        />
      )}

      {showLabel && (
        <span className="font-semibold">{config.label}</span>
      )}
    </span>
  );
};

export default ServiceStatusBadge;